import cx from "classnames";
import Link from "next/link";
import { PropsWithChildren } from "react";
import { ARTICLE_LINK_CLICKED } from "@/constants/amplitude";
import { Article } from "@/graphql/gql/graphql";
import { useAmplitude } from "@/utils/hooks/useAmplitude";
import ArticlePublishInfo from "./ArticlePublishInfo";
import styles from "./articleList.module.scss";

type ArticleListProps = {
  articles: Article[];
  type?: "columns" | "grid";
  origin: string;
  sportName: string;
};

type ContainerProps = Pick<ArticleListProps, "type">;

const Container = ({ type, children }: PropsWithChildren<ContainerProps>) => {
  const classes = cx({
    [styles.columns]: type === "columns",
    [styles.grid]: type === "grid",
  });

  return <ul className={classes}>{children}</ul>;
};

const ArticleList = ({
  articles,
  type = "columns",
  sportName,
  origin,
}: ArticleListProps) => {
  const { logAmplitudeEvent } = useAmplitude();
  return (
    <Container type={type}>
      {articles.map((article) => (
        <li className={styles.listItem} key={article.id}>
          <h3 className={styles.heading}>
            {article.title && (
              <Link
                onClick={() =>
                  logAmplitudeEvent(ARTICLE_LINK_CLICKED, {
                    "Link Text": article.title,
                    "Link URL": `/${article.slug}`,
                    Module: origin,
                    Competition: sportName,
                  })
                }
                href={`/${article.slug}`}
              >
                {article.title}
              </Link>
            )}
          </h3>
          <div className={styles.boxArticlePublishInfo}>
            <ArticlePublishInfo
              sportName={article.sport.name}
              sportSlug={article.sport.slug}
              date={article.firstPublishedAt}
            />
          </div>
        </li>
      ))}
    </Container>
  );
};

export default ArticleList;
